import React from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

interface ImportPreviewDialogProps {
  open: boolean;
  previewData: any[];
  onConfirm: () => void;
  onCancel: () => void;
  isConfirming: boolean;
}

const ImportPreviewDialog: React.FC<ImportPreviewDialogProps> = ({
  open,
  previewData,
  onConfirm,
  onCancel,
  isConfirming
}) => {
  const validCount = previewData.filter((d) => d.valid).length;
  const invalidCount = previewData.length - validCount;

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="lg" fullWidth>
      <DialogTitle>Import Preview</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" gutterBottom>
          Ready to import
          {' '}
          {validCount}
          {' '}
          valid marks.
          {' '}
          {invalidCount}
          {' '}
          marks have errors.
        </Typography>

        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Row</TableCell>
              <TableCell>Address</TableCell>
              <TableCell>Lat/Lng</TableCell>
              <TableCell>Market</TableCell>
              <TableCell>Categories</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {previewData.map((row) => (
              <TableRow key={`row-${row.row}`} sx={{ backgroundColor: row.valid ? 'inherit' : '#ffebee' }}>
                <TableCell>{row.row}</TableCell>
                <TableCell>{row.address}</TableCell>
                <TableCell>
                  {row.latitude && row.longitude ? `${row.latitude.slice(0, 6)}, ${row.longitude.slice(0, 6)}` : 'N/A'}
                </TableCell>
                <TableCell>{row.marketName || (row.importMarketId ? `ID: ${row.importMarketId}` : 'N/A')}</TableCell>
                <TableCell>
                  {row.categoryNames && row.categoryNames.length > 0
                    ? row.categoryNames.join(', ')
                    : [row.iceCream && 'Ice', row.pastry
                    && 'Pastry', row.pudding && 'Pudding'].filter(Boolean).join(', ') || 'N/A'}
                </TableCell>
                <TableCell sx={{ color: row.valid ? 'success.main' : 'error.main' }}>
                  {row.valid ? 'Valid' : row.error}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isConfirming}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color="primary" disabled={isConfirming || validCount === 0}>
          {isConfirming ? 'Confirming...' : 'Confirm Import'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImportPreviewDialog;
